import request from '@/utils/request'

let GradeCardApi = {
  /*会员卡列表*/
  GradeCardlist(data, errorback) {
      return request._post('/shop/plus.gradecard.GradeCard/index', data, errorback);
  },
  /*会员等级*/
  gradeList(data, errorback) {
      return request._get('/shop/plus.gradecard.GradeCard/add', data, errorback);
  },
  /*添加会员卡*/
  addGradeCard(data, errorback) {
      return request._post('/shop/plus.gradecard.GradeCard/add', data, errorback);
  },
  /*会员卡详情*/
  GradeCardDetail(data, errorback) {
      return request._post('/shop/plus.gradecard.GradeCard/detail', data, errorback);
  },
}
export default GradeCardApi;



// WEBPACK FOOTER //
// ./src/api/gradecard.js